import firebase from 'firebase';
//eslint-disable-next-line
import firestore from 'firebase/firestore';

firebase.initializeApp({
    apiKey: 'AIzaSyCDBD15bxHhq0GNC_Vom4Iehk-hPJqCuOg',
    authDomain: 'integrar-5ee17.firebaseapp.com',
    databaseURL: 'https://integrar-5ee17.firebaseio.com',
    projectId: 'integrar-5ee17',
    storageBucket: 'integrar-5ee17.appspot.com',
    messagingSenderId: '139476438354'
})

export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = firebase.storage();

export const keygen = () => {
    let keygenRef = firebase.firestore().collection('keygen').doc();
    return keygenRef.id;
}



// WEBPACK FOOTER //
// ./src/services/firebase/index.js